import type { PublicLegalFooterDocumentPdfPaths } from "le-coffre-resources/dist/publicLegalStaticPaths";

/** Aligné sur `GET /v1/public/site-config` → `public_ui` (voir `sites.theme_json.public_ui`). */
export type PublicSitePublicUiOptions = {
	uses_operation_folder_lexicon: boolean;
	login_show_center_brand_mark: boolean;
	login_callback_show_lecoffre_logo: boolean;
	header_logo_variant: "default" | "compact";
	merge_dark_public_shell_theme: boolean;
	login_show_idnot_notary_connection: boolean;
	/** Libellés « étude / office » (ligne notaire) vs lexique `workspace*` (autres lignes). */
	uses_estate_workspace_terms_in_ui_copy: boolean;
	/** Bloc lien portail Id.not sur Mon compte. */
	my_account_show_idnot_portal_link: boolean;
};

export const DEFAULT_PUBLIC_SITE_PUBLIC_UI_OPTIONS: PublicSitePublicUiOptions = {
	uses_operation_folder_lexicon: false,
	login_show_center_brand_mark: true,
	login_callback_show_lecoffre_logo: true,
	header_logo_variant: "default",
	merge_dark_public_shell_theme: false,
	login_show_idnot_notary_connection: true,
	uses_estate_workspace_terms_in_ui_copy: true,
	my_account_show_idnot_portal_link: true,
};

export type PublicSiteIntegrationFlags = {
	uses_idnot: boolean;
	uses_docv_oauth: boolean;
	uses_mailchimp: boolean;
	uses_ovh_sms: boolean;
	uses_stripe: boolean;
	allows_v1_import: boolean;
};

/** Bloc `public_legal_static` de `GET /v1/public/site-config` (PDFs footer + guide, toutes lignes). */
export type PublicLegalStaticLoaded = {
	footer_documents_prefix: string;
	user_guide_entry_path: string;
	document_pdf_paths: PublicLegalFooterDocumentPdfPaths;
};

export type LoadedPublicSiteConfig = {
	/** Partition déploiement renvoyée par l’API (source de vérité pour le filtrage branding, vs build `NEXT_PUBLIC_SITE_CODE`). */
	site_code?: string;
	public_ui: PublicSitePublicUiOptions;
	integration_flags: PublicSiteIntegrationFlags;
	/** `sites.label` for the active deployment line, when returned by the API. */
	display_name?: string | null;
	product_code?: string;
	theme?: { css_vars?: Record<string, string> };
	branding?: {
		logo_main_url?: string | null;
		logo_small_url?: string | null;
		favicon_url?: string | null;
	};
	public_legal_static: PublicLegalStaticLoaded;
};
